import { Box } from '@fhs-legacy/universal-components';
import { theme } from 'styles/configure-theme';

export const StoreCardWrapper = Box.withConfig({
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: theme.token('border-color-default'),
});
